<template>
    <div>
        <p style="font-size:16px">请在下方的开标记录明细中选择投标报价：</p>
        <div class="kbjl">
            <my-table :data="kbjlmx">
                <el-table-column 
                    label="报价类型" 
                    fixed="left"
                    min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.mxtype=='1'">金额</span>
                            <span v-if="scope.row.mxtype=='2'">费率/比率/优惠率/合格率等</span>
                            <span v-if="scope.row.mxtype=='3'">单价</span>
                            <span v-if="scope.row.mxtype=='4'">其他形式</span>
                        </template>
                </el-table-column>
                <el-table-column 
                    label="金额"
                    prop="nodevalue"  
                    min-width="100">
                </el-table-column>
                <el-table-column 
                    label="单位"
                    prop="unit"  
                    min-width="50">
                </el-table-column>
                <el-table-column 
                    label="操作" 
                    fixed="right"
                    width="160">
                        <template slot-scope="scope">
                            <el-button 
                                type="primary" 
                                @click="confirm(scope.row)"
                                icon="el-icon-circle-check"
                                size="small">
                                    确定
                            </el-button>
                        </template>
                </el-table-column>
            </my-table>
            
        </div>
        <div style="text-align:center">
            
             <el-button 
                type="warning" 
                @click="cancel"
                icon="el-icon-circle-close"
                size="small">
                    取消
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return{
            kbjlmx:[],
            nodekey:'',
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        confirm(node){
            var that = this
            that.$emit('cancle',node)
        },
        cancel(){
            this.$emit('cancle','')
        }

    },
    created() {
        
    },
    mounted() {
        var that=this;
        that.kbjlmx = that.data;
        console.log(that.data)
        
    }
}
</script>

<style scoped lang="scss">
    .kbjl{ margin-top: 20px; }
    /deep/ .kbjl .el-radio{ display: block; margin-bottom: 15px; } 
</style>
